import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextareaAutosize,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { getInfosAccountRestricted } from '@webapps/business';
import {
  Button,
  useQuery,
  useStrophe,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

const signInSchema = yup.object().shape({
  message: yup.string().required('Requis'),
});

const MessageBox = ({ id, onCancel }) => {
  const {
    css,
    theme: { spacing },
  } = useStyles();

  const { sendMessage } = useStrophe();
  const { addToast } = useToast();

  const { data: accountInfos = {} } = useQuery(getInfosAccountRestricted, {
    key: 'accountInfos',
    variables: { id },
  });

  const formik = useFormik({
    initialValues: {
      message: '',
    },
    validationSchema: signInSchema,
    onSubmit: ({ message }, { resetForm }) => {
      sendMessage({
        to: `${accountInfos?.alias}@linkpick.fr`,
        msg: message,
      });
      resetForm();
      setCount(0);
      onCancel();
      addToast({
        status: 'success',
        message: 'Message envoyé',
      });
    },
  });

  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(formik.values.message?.length);
  }, []);

  return (
    <>
      <Grid
        className={css({ paddingTop: spacing(2), display: 'flex', '@media only screen and (max-width:768px)': { paddingBottom: spacing(1), paddingTop: spacing(2) }, })}
        container
        spacing={2}
      >
        <Grid item xs={12}>
          <TextareaAutosize
            className={css({ width: '100%', height: '100%', resize: 'none', fontFamily: 'Roboto', backgroundColor: '#F3F7FF', borderRadius: '5px', border: '1px solid #C0D9FF' })}
            error={formik.touched.message && Boolean(formik.errors.message)}
            helperText={formik.touched.message && formik.errors.message}
            maxLength={500}
            minRows={18}
            name="message"
            onChange={(e) => {
              formik.handleChange(e);
              setCount(formik.values.message?.length);
            }}
            value={formik.values.message}
          />
          <div style={{ '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'}, }}>{count} / 500</div>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid className={css({ textAlign: 'center' })} item xs>
          <Button
            className={css({ borderRadius: '400px', marginBottom: spacing(1) })}
            color="primary"
            onClick={formik.handleSubmit}
            variant="contained"
          >
            <FormattedMessage id="school.btnSend" />
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

MessageBox.propTypes = {
  id: PropTypes.string,
};

export default MessageBox;
